<template>
    <v-dialog v-model="dialog" hide-overlay transition="dialog-bottom-transition" max-width="600px">
        <template v-slot:activator="{ on, attrs }">
            <v-btn color="teal darken-4" dark class="d-flex rounded-xl" v-bind="attrs" v-on="on" outlined
            style="text-transform: none;">Xuất excel</v-btn>
        </template>
        <v-card>
            <v-card-title class=""> Xuất excel
                <v-spacer></v-spacer>
                <v-icon color="white" @click="dialog=false">mdi-close</v-icon>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-autocomplete
                        :items="formData.departments"
                        v-model="form.DepartmentCodes" label="Phòng"
                        multiple clearable
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                        <v-autocomplete multiple item-text="name" item-value="code" :items="formData.employees" v-model="form.employeeCodes"
                        label="Nhân viên" hide-no-data :rules='[v=>!!v||"Chọn dữ liệu"]' clearable>
                            <template v-slot:selection="data">
                                <strong>{{ data.item.code }}</strong> {{`: ${data.item.name} - ${data.item.department!=null? data.item.department: 'Chưa phân công'}`}}; 
                            </template>
                            <template v-slot:item="data">
                                <strong>{{ data.item.code }} </strong> {{`: ${data.item.name} - ${data.item.department!=null? data.item.department: 'Chưa phân công'}`}}
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="6">
                        <date-picker2 :range="false" v-model="form.from" label="Từ ngày" :width="500"></date-picker2>
                    </v-col>
                    <v-col cols="6">
                        <date-picker2 :range="false" v-model="form.to" label="Đến ngày" :width="500"></date-picker2>
                    </v-col>
                    <v-col cols="12">
                        <v-autocomplete multiple label="Trạng thái" :items="[
                            {text: 'Xác nhận', value:1},
                            {text: 'Từ chối', value:2},
                            {text: 'Chờ', value:0},
                        ]" v-model="form.statuses" clearable>
                        </v-autocomplete>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed dark color="teal darken-4" @click="getExport">
                    <v-icon small left>mdi-download</v-icon>
                    Tải về file
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import * as moment from "moment/moment"
import http from '@/components/services/http-common';
import UploadService from "@/components/services/UploadService";
import EventBus  from "@/components/services/EventBus";
import DatePicker from "@/components/DatePicker";

export default {
    name: "Excel",
    props: ['value'],
    components: {
        "date-picker": DatePicker
    },
    computed:{
        dialog: {
            get: function () {
                return this.value;
            },
            set: function (val){
                this.$emit("input", val)
            }
        },
    },
    watch: {
      options: {
            handler (val) {
                this.fetchData();
            },
            deep: true,
        },
    },
    data () {
        return {
            progress: 0,
            currentFiles: undefined,
            message: "",
            fileInfos: [],

            //**************** TABLE CONFIG */
            employees: [],
            options: {},
            totalItem: 0,
            isLoading: false,

            formData: {
                employees:[],
                departments: [],
            },
            form: {
                employeeCodes: [],
                departmentCodes: [],
                statuses: [],
                from: moment().startOf("months").format("YYYY-MM-DD"),
                to: moment().endOf("months").format("YYYY-MM-DD"),
            },

            //************* data table config ********
            headers: [
                { text: 'Mã nhân viên', value: 'code' },
                {
                    text: 'Tên nhân viên',
                    align: 'start',
                    sortable: false,
                    value: 'name',
                },
                { text: 'Hợp đồng', value: 'contract', sortable: false },
                // { text: 'Phúc lợi', value: 'benefit', sortable: false },
                { text: 'Giới tính', value: 'gender' },
                { text: 'Ngày sinh', value: 'birthday' },
                { text: 'Chức vụ', value: 'position' },
                { text: 'Phòng ban', value: 'department' },
                { text: 'Khối', value: 'group' },
            ],
        }
    },
    methods: {
        formatDate(value) {
            return moment(value).format("DD/MM/YYYY");
        },
        
        fetchEmployee(val) {
            return http.get("employees/search").then(res => {
                console.log(res.data)
                this.formData.employees = res.data;
            });
        },
        fetchData () {
            const { sortBy, sortDesc, page, itemsPerPage } = this.options;
            if(page != undefined || itemsPerPage != undefined)
                http.get('employees/preview-export?page='+ page + '&pageSize=' + itemsPerPage, {
                    params: this.form
                }).then(res => {
                    this.isLoading = false;
                    this.employees = res.data.items;
                    this.totalItem = res.data.totalItem;
                }).catch(err => {
                    console.log(err);
                });
        },

        fetchDepartmentType() {
            http.get("departmenttypes?dropDown=1").then(res => {
                this.formData.departmentTypes = res.data.map(function(obj) {
                return {
                    text: obj.name,
                    value: obj.code,
                    }
                });
            })
            .catch(err => {
                console.log("err");
            });
        },
        fetchDepartment() {
            this.form.DepartmentCode = '';
            this.formData.departments = [];
            if(this.form.DepartmentTypeCode != '')
                http.get("departments?dropDown=1").then(res => {
                    this.formData.departments = res.data.map(function(obj) {
                    return {
                        text: obj.name,
                        value: obj.code,
                        }
                    });
                }).catch(err => {
                    console.log(err);
                });
        },
        
        fetchPosition() {
            http.get("positions?dropDown=1").then(res => {
                this.formData.positions = res.data.map(function(obj) {
                return {
                    text: obj.name,
                    value: obj.code
                    }
                });
            }).catch(err => {
                console.log(err);
            });
        },

        fetchShift() {
            if(this.form.DepartmentTypeCode != '')
                http.get("departmenttypes/fetch-shift/" + this.form.DepartmentTypeCode).then(res => {
                    this.formData.shifts = res.data.map(function(obj) {
                    return {
                        text: obj.name,
                        value: obj.code,
                        }
                    });
                    console.log(res)
                }).catch(err => {
                    console.log(err);
                });
        },
        selectFile(files) {
            this.progress = 0;
            this.currentFiles = files;
        },
        upload() {
            if (!this.currentFiles) {
                this.message = "Chọn file excel!";
                return;
            }

            this.message = "";
            UploadService.upload(this.currentFiles, (event) => {
                this.progress = Math.round((100 * event.loaded) / event.total);
            }, "employees/import-data")
            .then((response) => {
                let eventObj = {
                    color: "success",
                    messages: "Upload file thành công!!"
                }
                EventBus.$emit('hasMessage', eventObj);
                this.$emit("needFetch");
                // this.message = response.data.message;
            // return {"data": [{"url": "url xxxx", "name": "xxx"}]};
            })
            .catch((error) => {
                if(error.response.status){
                    let eventObj = {
                        color: "error",
                        messages: "Đã có lỗi xảy ra, vui lòng kiểm tra dữ liệu file!"
                    }
                    EventBus.$emit('hasMessage', eventObj);
                }
                switch (error.response.status) {
                    case 401: {
                        console.log("co loi xay ra");
                    break;
                    }
                    case 500: {
                        console.log("co loi xay ra");
                    break;
                    }
                }
            
            this.currentFiles = undefined;
            this.progress = 0;
            this.message = "Could not upload the file!";
            this.currentFiles = undefined;
            });
        },
        getExport() {
            http.get("overtimeRequests/export", {
                params: this.form,
                responseType: 'arraybuffer',
            }).then((res)  => {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'DU_LIEU_PHIEU_LAM_THEM.xlsx'); //or any other extension
                document.body.appendChild(link);
                link.click();
            }).catch((err)  => {
                console.log(err);
            });
        },
    },
    created () {
        this.fetchEmployee();
        this.fetchDepartment();
    }
}
</script>